module.exports = __webpack_public_path__ + "static/assets/d44db8ebf3c5fae69e189ca6962a7c14.svg";